import React, { useState, useEffect } from 'react';
import CustomMargin from '../../../components/custom-margin';
import QuotationMark from '../../../assets/quotation-mark.svg';
import { chunkArray } from '../../../components/functions';
import { truncateText } from '../../../components/functions';
import SubmitTestimonial from './submit-testimonial';
import axios from 'axios';
import { PROXY } from '../../../components/constants';


export default function TestimonialCard() {
    const [startNum, setStartNum] = useState(6);
    const [testimonial, setTestimonial] = useState([]); 
    const chunkTestimonial = chunkArray(testimonial.slice(0, startNum), 3);
    const [expandedIndexes, setExpandedIndexes] = useState({});
    const [feedbackSubmit, setFeedbackSubmit] = useState(false);

    const handleExpandClick = (arrayIndex, index) => {
        setExpandedIndexes(prevState => ({
            ...prevState,
            [arrayIndex]: prevState[arrayIndex] === index ? null : index
        }));
    };

    const handleClickMore = (num) => {
        setStartNum((prev) => prev + num);
    }

    const handleFeedback = () => {
        setFeedbackSubmit(!feedbackSubmit);
    }

    useEffect(() => {
        fetchFeedback();
    }, [])

    const fetchFeedback = () => {
        axios.get(`${PROXY}/fetch_approved_feedback`)
        .then(res => {
            setTestimonial(res.data);
        })
        .catch(err => console.error(err));
    }


    return (
        <div className='m-auto max-w-7xl'>
            <CustomMargin className='flex w-full flex-col gap-5 p-5 lg:px-10'>
                {chunkTestimonial.map((arrayData, arrayIndex) => (
                    <div key={arrayIndex} className='flex sm:flex-col lg:flex-row gap-5'>
                        {arrayData.map((testimonial, index) => {
                            const { truncated, isTruncated } = truncateText(testimonial.details, 40);
                            const isExpanded = expandedIndexes[arrayIndex] === index;

                            return (
                                <div key={index} className={`flex w-full gap-4 rounded-2xl border border-zinc-700/80 bg-gradient-to-br from-zinc-900 to-[#0c0c0c] p-6 shadow-xl shadow-black/20 transition-all duration-300 hover:border-zinc-500 lg:w-1/3 sm:mt-5 ${isExpanded ? 'h-auto' : ''}`}
                                >
                                    <img alt='quotation mark' src={QuotationMark} className='h-7 w-7 scale-x-[-1] opacity-60 invert' />
                                    <div className='flex flex-col'>
                                        <h2 className='font-fontMontserrat text-2xl text-zinc-100'>{testimonial.title}</h2>
                                        <p className="mt-3 leading-7 text-zinc-400">{isExpanded ? testimonial.details : truncated}</p>
                                        {isTruncated && !isExpanded && (
                                            <div
                                                className='mt-3 cursor-pointer font-mono text-sm text-zinc-500 transition hover:text-white'
                                                onClick={() => handleExpandClick(arrayIndex, index)}
                                            >
                                                [+]
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ))}
            </CustomMargin>
            <div className='flex flex-col m-auto w-full'>
                <div className='sm:p-5'>
                    <button className={`mt-10 flex items-center rounded-xl border border-zinc-600 bg-zinc-900 px-6 py-3 text-sm tracking-[0.12em] text-zinc-200 transition hover:border-zinc-300 hover:text-white ${testimonial.length < startNum ? 'hidden' : ''}`}
                        onClick={() => handleClickMore(3)}
                    >
                        <p className=''>MORE TESTIMONIAL</p>
                        <small className='text-xs'>&#65125;&#65125;</small>
                    </button>
                </div>
                <div className='mt-10 border-t border-zinc-700 p-5'>
                    <p className='font-fontMontserrat text-xl text-zinc-100'>Have You Worked With Us?</p>
                    <button
                        onClick={() => handleFeedback()}
                        className='mt-5 rounded-xl border border-zinc-600 bg-gradient-to-b from-zinc-800 to-zinc-950 px-7 py-4 text-sm tracking-[0.12em] text-zinc-100 transition hover:border-zinc-300'>Leave Us Feedback</button>
                </div>
            </div>
            {feedbackSubmit && (
                <SubmitTestimonial/>
            )}
        </div>
    );
}
